/*
 *  Interface représentant une facture client telle qu'utilisée dans l'application React et l'application API
 */

import { StatusConfig } from '@common/components/StatusCard/StatusCard';
import {
	faCircleCheck,
	faFileAlt,
	faPaperPlane,
	faSpinner,
	faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { ActivityData } from 'features/activities';
import { AdvanceData } from 'features/advances/types/types';
import { CreditNoteData } from 'features/creditNotes/types/types';
import { LogisticElementData } from 'features/logisticElements';
import { ProjectData } from 'features/projects';
import { UserData } from 'features/users';

export interface CustomerInvoiceData {
	workflowLock?: { locked: boolean; message: string; remedy: string } | null;
	// Obligatoires
	id: number;
	referenceNumber: string;
	// Champs simples
	invoiceDate?: Date;
	dueDate?: Date;
	fiscalYear?: number;
	label?: string;
	acceptanceReport?: string;
	status?: string;
	// Champ calculé (somme activités + éléments logistiques, retourné par le backend)
	totalExclTax?: number;
	// Relations
	project?: ProjectData | null;
	advances?: AdvanceData[];
	activities?: ActivityData[];
	creditNotes?: CreditNoteData[];
	logisticElements?: LogisticElementData[];
	// Métadonnées
	createdAt?: Date;
	createdBy?: UserData | null;
}

export const CUSTOMER_INVOICE_STATUS_CONFIG: StatusConfig = {
	steps: [
		{
			key: 'CANCELED',
			icon: faTimesCircle,
			color: 'bg-red-600 text-white',
			textColor: 'text-red-600',
			label: 'Annulée',
			side: true,
		},
		{
			key: 'DRAFT',
			icon: faFileAlt,
			color: 'bg-blue-600 text-white',
			textColor: 'text-blue-600',
			label: 'Brouillon',
		},
		{
			key: 'ISSUED',
			icon: faPaperPlane,
			color: 'bg-purple-500 text-white',
			textColor: 'text-purple-600',
			label: 'Émise',
		},
		{
			key: 'PARTIALLY_PAID',
			icon: faSpinner,
			color: 'bg-blue-600 text-white',
			textColor: 'text-blue-600',
			label: 'Partiellement payée',
		},
		{
			key: 'PAID',
			icon: faCircleCheck,
			color: 'bg-green-600 text-white',
			textColor: 'text-green-600',
			label: 'Payée',
		},
	],

	transitions: {
		CANCELED: [{ to: 'DRAFT', label: 'Brouillon', type: 'main' }],
		DRAFT: [
			{ to: 'CANCELED', label: 'Annuler', type: 'secondary' },
			{ to: 'ISSUED', label: 'Émettre', type: 'main' },
		],
		ISSUED: [
			{ to: 'DRAFT', label: 'Brouillon', type: 'secondary' },
			{ to: 'PARTIALLY_PAID', label: 'Paiement partiel', type: 'main' },
		],
		PARTIALLY_PAID: [
			{ to: 'ISSUED', label: 'Émise', type: 'secondary' },
			{ to: 'PAID', label: 'Payer', type: 'main' },
		],
		PAID: [{ to: 'CANCELED', label: 'Annuler', type: 'secondary' }],
	},
};
